import { WidgetProps } from "@rjsf/core";
import { WorkflowTasks } from "components/WorkflowTasks";
import { isTaskCompleted } from "components/WorkflowTasks/utils";
import { useEffect, useRef } from "react";
import { WorkFlowTaskModel, WorkflowTaskStepType } from "../../../../WorkflowTasks/types";

export const WorkflowWidget = (props: WidgetProps) => {
    const { applicationNumber, workflowWidgetRef, onWorkflowLoaded, appSubmitted, isWorkflowTask, codeNumber } = props.formContext ?? {};

    const isWorkflowLoaded = useRef(false);

    // Setup widget
    useEffect(() => {
        if (workflowWidgetRef) {
            workflowWidgetRef.current = {
                fieldNumber: props.uiSchema["af:fieldNumber"],
            };
        }

        return () => {
            if (workflowWidgetRef?.current) {
                workflowWidgetRef.current = undefined;
            }
        };
    }, [props.uiSchema, workflowWidgetRef]);

    const onChange = (workflow: WorkFlowTaskModel[], disableUploadFileReq?: boolean) => {
        if (isWorkflowLoaded.current) {
            const value = workflow
                .filter((task) => !codeNumber || task.stepType === WorkflowTaskStepType.DocumentUpload)
                .every((t) => isTaskCompleted(t) || disableUploadFileReq)
                ? "true"
                : "false";

            setTimeout(() => {
                props.onChange(value);
            });
        }
    };

    const onLoaded = () => {
        isWorkflowLoaded.current = true;
        onWorkflowLoaded?.();
    };

    if (isWorkflowTask || appSubmitted) {
        return null;
    }

    return (
        <div className="workflow-widget py-2">
            <WorkflowTasks applicationNumber={applicationNumber} onChange={onChange} onWorkflowLoaded={onLoaded} codeNumber={codeNumber} />
        </div>
    );
};
